import React from 'react';
import _ from 'lodash';
import Workbook from 'vendor/react-excel-workbook';

export const getExportData = (taskData, exportColumns) => {
  let exportData = _.map(taskData, (task) => {
    let columns = {};
    _.forEach(exportColumns, (column) => {
      if (_.toLower(_.get(column, 'type')) === 'dollar') {
        _.set(columns, _.get(column, 'key'), '$' + _.get(task, _.get(column, 'path'), 0));
      } else {
        _.set(columns, _.get(column, 'key'), _.get(task, _.get(column, 'path'), ''));
      }
    });
    return columns;
  });
  return exportData;
};

export const getHeaders = (exportColumns) => {
  return _.map(exportColumns, (column) => {
    return (
      <Workbook.Column label={_.get(column, 'header')} value={_.get(column, 'key')} />
    );
  });
};

export const GenericWorkBook = ({exportRef, taskData, exportColumns, exportName}) => {
  const exportData = getExportData(taskData, exportColumns);
  return (
    <Workbook filename={exportName + '.xlsx'} element={<span ref={exportRef} />}>
      <Workbook.Sheet data={exportData} name="Dashboard Sheet">
        {getHeaders(exportColumns)}
      </Workbook.Sheet>
    </Workbook>
  );
};

export default GenericWorkBook;
